<template>
    <modal
        class="subscribe-bi"
        :adaptive="true"
        width="930px"
        height="540px"
        name="subscribe-bi"
    >
        <div class="close-modal" @click="$modal.hide('subscribe-bi')">
            <img src="@assets/img/x-gray.svg" alt="X" width="20px">
        </div>
        <div class="subscribe-bi-container">
            <h1>Ready for your daily delivery of inspiration?</h1>
            <p>Sign up for our FREE Book Insight of the day email and start learning.</p>
            <email-capture-form />
        </div>
    </modal>
</template>

<script>
export default {
    name: "SubscribeBi",
    components: {
        emailCaptureForm: () => import(/* webpackChunkName: "email-capture-form"*/ "@c/books-insights/email-capture-form")
    }
}
</script>

<style lang="scss">
.subscribe-bi {
    .close-modal {
        position: absolute;
        right: 20px;
        top: 15px;
        cursor: pointer;
    }

    .v--modal-box {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 50px 140px;
        border-radius: 20px;
        background-color: #F4EBF6;

        .subscribe-bi-container {
            h1 {
                color: $medium-gray;
                font-family: "Gibson";
                font-size: 40px;
                font-weight: 600;
                line-height: 50px;
                text-align: center;
                margin-bottom: 20px;
            }

            p {
                color: $medium-gray;
                font-family: "Gibson";
                font-size: 17px;
                line-height: 27px;
                text-align: center;
                margin-bottom: 30px;
            }
        }
    }
}
</style>
